module.exports = __webpack_public_path__ + "c_static/img/1-1收藏宝贝.81ae795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-1收藏宝贝.jpg
// module id = 617O
// module chunks = 33